<template>
    <div class="main">
        <div class="breadcrumb">
        </div>
        <xy-toolbox-menu>
            <xy-toolbox-menu-item divided/>
            <xy-toolbox-menu-item icon="car_search" @click="gocompare">返回</xy-toolbox-menu-item>
            <xy-toolbox-menu-item icon="excel" @click="test">导出</xy-toolbox-menu-item>
        </xy-toolbox-menu>
        <div class="pk1box">
            <h3> </h3>
            <div v-html="content"></div>
            <h3> </h3>
        </div>
    </div>
</template>
<script>
    const OptionPattern = /\(选装:(.*?)\)/g;
      const HasDigit  =/\d+/;
    import {
        mapMutations,
        mapGetters,
        mapActions
    } from "vuex";
    import SearchBar from "@/components/common/EquipSearch.vue";
    import {
        formatDate,
        strToFormatDate
    } from "@/plugins/DateTimeFormater.js";
    export default {
        name: "equippk2",
        data() {
            return {
                categories: [],
                pklist: [],
                pkids: [],
                paramData: [],
                lines: [],
                excelData: [],
                content: 'loading...',
                viewValue: 1,
                viewOptions: [{
                    value: 1,
                    label: '显示全部'
                }, {
                    value: 2,
                    label: '仅显示相同'
                }, {
                    value: 3,
                    label: '仅显示优劣势'
                }],
            };
        },
        methods: {
            ...mapActions("equipanalysis", ["queryEquipParams"]),
            async queryData() {
                var postData = {
                    ids: this.pkids
                };
                this.queryEquipParams({
                    params: postData
                });
            },
            bindData() {
                this.paramData = this.equipParamsList.dataDict;
                this.lines = this.equipParamsList.lines;
                this.categories = this.equipParamsList.categories.filter(x =>
                    x.name != "参数" && x.name != "动力"
                );
                // this.pklist.forEach(x => {
                //     this.makeContent(x);
                // });
                this.buddle_sort(this.lines);
                //alert(JSON.stringify(this.lines));
                 var arrlen = this.lines.length + 1;
                 var   html = ' <div class="pk-content" style="grid-template-columns: ' + " auto".repeat(arrlen) + ';">';
                for (var i = 0; i < arrlen; i++) {
                    if (i == 0) {
                        html += ' <div class="item car-label gy">名称</div>';
                    } else {
                        var line = this.lines[i-1];
                        html += ' <div class="item car-name">' + line.name + '  <div> 价格：￥ ' + line.price + '</div> </div>';
                    }
                }
                for (var i = 0; i < arrlen; i++) {
                    if (i == 0) {
                        html += ' <div class="item car-label gy">MSRP %</div>';
                    } else {
                        var line = this.lines[i-1];
                        html += ' <div class="item car-name"> ￥ ' + (line.msrp - line.price) + ' </div>';
                    }
                }

                   for (var i = 0; i < arrlen; i++) {
                    if (i == 0) {
                        html += ' <div class="item car-label gy">装备</div>';
                    } else {
                      
                        if(i==1)
                        {
                              var pk1a = this.find_line(this.lines[0].id);
                            var pk2a = this.find_line(this.lines[1].id);
                           html += ' <div class="item car-name">'+this.pk(pk1a ,pk2a,1)  +' </div>';
                        }else{
                              var pk1a = this.find_line(this.lines[i-1].id);
                            var pk2a = this.find_line(this.lines[i-2].id);
                       html += ' <div class="item car-name">'+this.pk(pk1a ,pk2a,1)  +' </div>';
                        }
                     
                    }
                }
                  for (var i = 0; i < arrlen; i++) {
                    if (i == 0) {
                        html += ' <div class="item car-label gy">名称</div> ';
                    } else {
                        var line = this.lines[i-1];
                       html += ' <div class="item car-name">' + line.name + '  <div> 价格：￥ ' + line.price + '</div> </div>';
                    }
                }
                html += '</div>';
                this.content = html;
            },
     pk(equip1, equip2,  type) {
        var list = [];
       
        var html = '';
        var html = '<ul class="ls-plus">';
        equip1.forEach(x => {
      
            if (type == 1) {
              var fd = equip2.find(item => item.name == x.name);
              if (!fd || fd.val != x.val) {
                if (!HasDigit.test(x.val)) {
                  html += '<li>+ ' + x.val + ' </li>';
                } else {
                  html += '<li>+ ' + x.name + ":" + x.val + '</li> ';
                }
              }
            } else if (type == 2) {
              var fd = equip2.find(item => item.name == x.name);
              if (fd && fd.val == x.val) {
               if (!HasDigit.test(x.val)) {
                  html += '<li>+ ' + x.val + ' </li>';
                } else {
                  html += '<li>+  ' + x.name + ":" + x.val + '</li> ';
                }
              }
            }
           
        });
        html += "</ul> ";
        return html;
      },
           
           test() {},
            gocompare() {
                this.$router.push({
                    name: 'equipcompare'
                });
            },
            buddle_sort(arr) {
                let len = arr.length - 1
                for (let j = 0; j < len; j++) {
                    for (let i = 0; i < len - j; i++) {
                        if (arr[i].msrp > arr[i + 1].msrp) {
                            [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
                        }
                    }
                }
            },
            find_line(id) {
                var result = [];
                var opts = [];
                var aaa;
                for (var i = 0; i < this.paramData.length; i++) {
                    var r = this.paramData[i];
                    for (var j in r.lines) {
                        if (j == id) {
                            var val = r.lines[j];
                            if (val != "-") {
                                var line = {
                                    id: id,
                                    tag: r.tag,
                                    name: r.name,
                                    val: val
                                };
                                result.push(line);
                            }
                        }
                    }
                }
                return result;
            }
        },
        mounted() {
            var params = this.$route.params.q;
            if (params == undefined) {
                return;
            }
            //   alert(JSON.stringify(params));
            var ids = new Set();
            params.forEach(x => {
                if (x != null) {
                    x.forEach(y => {
                        if (y) {
                            ids.add(y.carId);
                        }
                    });
                }
            });
            this.pkids = [...ids];
            this.queryData();
        },
        computed: {
            ...mapGetters("equipanalysis", {
                equipParamsList: "equipParamsList"
            })
        },
        watch: {
            equipParamsList(value) {
                this.bindData();
            }
        }
    }
</script>

